import React from 'react';

import { Iframe } from '@gogame/components';

export default ({ src, width, height, maxWidth, maxHeight }) => {
  return (
    <Iframe
      src={src}
      width={width}
      height={height}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      frameborder={'0'}
      scrolling={'no'}
    />
  );
};
